/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-11 10:36:17
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-03-16 17:03:35
 * @Description: file content
 */
import { CustomConfig } from './types';

const onlineConfig: CustomConfig = {
  baseUrl: '',
  api: {
    h5: '/h5',
    activity: '/support/interface/activity',
    app: '/appgw/v2',
    service: '/agservice/service'
  }
};

export default onlineConfig;
